import Styles from "../../pages/Styles/NomineeStyles.module.scss";
import {
  Stack,
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  RadioGroupProps,
  TextFieldProps,
  OutlinedTextFieldProps,
  ButtonProps,
  FormHelperText,
} from "@mui/material";
import { ISelectProofProps } from "../../shared/dtos";
import proofEmpty from "../../Components/assets/Images/proofemptycircle.svg";
import proofDone from "../../Components/assets/Images/prooftickedcircle.svg";

interface IRadioProps extends RadioGroupProps {}

interface ITextProps extends OutlinedTextFieldProps {}

export default function SelectProof(
  props: IRadioProps & ITextProps & ISelectProofProps
) {
  const {
    textFieldValue,
    textFieldLabel,
    textFieldError,
    onTextFieldChange,
    textFieldHelperText,
    radioGroups,
    index,
    currentIndex,
    textFieldName,
    handleRadioButtonFieldChange,
    helperText,
    radioGroupValue,
    values,
    handleBlur,
  } = props;

  return (
    <div
      className={Styles.radioContainer}
      style={{
        display: currentIndex !== index ? "none" : "block",
      }}
    >
      <p className={Styles.selectproof}>Select Nominee Proof </p>
      <div style={{ paddingLeft: "10px" }}>
        <RadioGroup
          {...props}
          onChange={handleRadioButtonFieldChange}
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "20px",
            alignItems: "center",
            fontFamily: "inherit",
          }}
        >
          {radioGroups.map((item: any, index: number) => (
            <FormControlLabel
              key={index}
              value={item}
              style={{
                display: "flex",
                alignItems: "center",
                fontFamily: "inherit",
              }}
              control={
                <Radio
                  sx={{ width: "20px", height: "20px" }}
                  checkedIcon={<img src={proofDone} />}
                  icon={<img src={proofEmpty} />}
                />
              }
              label={
                <p
                  className={Styles.radioLabel}
                  style={{
                    color:
                      item === radioGroupValue ? "" : "var(--Grey-60, #999)",
                    fontFamily: "inherit !important",
                  }}
                >
                  {item}
                </p>
              }
              checked={item === radioGroupValue}
            />
          ))}
        </RadioGroup>
        <FormHelperText style={{ color: "#d32f2f" }}>
          {helperText}
        </FormHelperText>
      </div>
      {radioGroupValue && (
        <div className={Styles.NewDesignWrapper} style={{ marginTop: "30px" }}>
          <div className={Styles.newFeildWrapper}>
            <TextField
              autoComplete="off"
              fullWidth
              {...props}
              className={Styles.proofTextFeild}
              // fullWidth
              // size="small"
              id="outlined-basic"
              label="Enter ID Proof No"
              variant="outlined"
              name={textFieldName}
              value={textFieldValue.toUpperCase()}
              error={textFieldError}
              helperText={textFieldHelperText}
              onChange={onTextFieldChange}
              onBlur={handleBlur}
              inputProps={{
                sx: {
                  "&::label": {
                    fill: "#111827",
                    fontWeight: 400,
                    fontSize: "14px",
                  },
                  color: "var(--Black-Black-500, #6B7280)",
                  fontSize: "14px",
                  fontFamily: "inherit",
                },
                maxLength: 50,
                inputMode: "text",
              }}
              sx={{
                fieldset: {
                  borderColor: "#E5E7EB",
                  borderRadius: "100px",
                },
              }}
              InputLabelProps={{
                sx: {
                  color: "#6B7280",
                  fontWeight: 400,
                  fontSize: "14px",
                  "&.MuiFormLabel-filled": {
                    color: "#111827",
                    fontWeight: 400,
                    fontSize: "15px",
                    fontFamily: "inherit",
                  },
                },
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

function TextFieldComponent(props: ITextProps) {}
